import { html, PropertyValues, TemplateResult } from 'lit';
import {
  API_TYPE_NIRVANA,
  WEB_COMPONENT_EXECUTIVE_SUMMARY_WEBSITES_BLOCKED,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  GetWebsitesBlockedResponse, WebsitesBlockedPayload,
} from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { WebsitesBlockedComponent } from '../../../../websitesBlocked';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_WEBSITES_BLOCKED)
export class GzWebsitesBlockedWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: WebsitesBlockedPayload;

  @query('#gzWebsitesBlocked')
  private websitesBlocked: WebsitesBlockedComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getWebsitesBlocked: function (request: GetWidgetDataRequest): Observable<GetWebsitesBlockedResponse> {
              return of(this.getPayload().websitesCategories);
            }.bind(this)
          }
        }
      }
    };

    if (this.websitesBlocked) {
      if (!this.websitesBlocked.started) {
        this.websitesBlocked.injectDependencies(dependencies);
        this.websitesBlocked.start();
      } else {
        this.websitesBlocked.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html `
      <gz-websites-blocked id="gzWebsitesBlocked"
                           data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                           data-targets=${JSON.stringify(this.payload?.targets)}
                           data-can-drill-down=${true}
                           data-display-mode=${getDisplayMode()}
      ></gz-websites-blocked>`;
  }
}
